// extracted by mini-css-extract-plugin
export default {"authPage":"auth-page_authPage__F6cPu","content":"auth-page_content__-8xfG"};